<template>
  <div id="app">
    <v-app id="inspire">
      <Navigation v-if="!loading && Auth.EsLogged" :key="cntUpdate"></Navigation>
      <div v-if="loading">
        <BlockUI>{{$t('otros.procesando')}}</BlockUI>
      </div>
      <router-view v-resize="onResize"></router-view>
    </v-app>
  </div>
</template>

<script>
import Navigation from "@/components/NavigationV2";
import { mapGetters, mapState } from "vuex";
import globalTypes from "@/types/global";

export default {
  components: {
    Navigation
  },
  name: "app",
  data() {
    return {
      msg: "Bienvenido",
      cntUpdate: 1
    };
  },
  computed: {
    ...mapGetters({
      processing: globalTypes.getters.processing
    }),
    ...mapState(["loading", "Auth"])
  },
  methods:{
    updated(){
      this.cntUpdate++;
    },
    beforeUpdate(){
      this.cntUpdate++;
    },
    onResize() {
      if (window.innerWidth < 769) this.$store.commit("setMobile", true, { root: true });// this.isMobile = true;
      else this.$store.commit("setMobile", false, { root: true });
    },
  },
  mounted(){
    let locale = window.localStorage.getItem("_locale");
    console.log("locale "+locale);
    if(locale){
      this.$i18n.locale = locale;
    }
  }
};
</script>

<style>
</style>
